if (process.env.NODE_ENV === 'development') {
  module.exports = `${process.env.PUBLIC_URL}/env/env.dev.json`; // to make proxies work urls still need to be present in .env.development.local
} else {
  module.exports = `${process.env.PUBLIC_URL}/env/env.prod.json`;
}
